// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"37ae386f","949":"5816d6f2"}[chunkId] + ".chunk.js";
};